import React from 'react'
import CmsPageScreen from '../Component/CmsPageScreen'

function Udesh() {
  return <CmsPageScreen pageId={1} />
}

export default Udesh
